import { z } from 'zod';

export const SPOT_STATUSES = ['free', 'reserved', 'occupied', 'cleaning'] as const;

export const spotStatusSchema = z.enum(SPOT_STATUSES);

export type SpotStatus = z.infer<typeof spotStatusSchema>;

// Live-status moves per §7; a spot needs cleaning whenever the floor says so.
export const SPOT_STATUS_TRANSITIONS: Readonly<Record<SpotStatus, readonly SpotStatus[]>> = {
  free: ['reserved', 'occupied', 'cleaning'],
  reserved: ['occupied', 'free', 'cleaning'],
  occupied: ['free', 'cleaning'],
  cleaning: ['free', 'occupied'],
};

export function canTransition(from: SpotStatus, to: SpotStatus): boolean {
  return SPOT_STATUS_TRANSITIONS[from].includes(to);
}

export function nextStatuses(from: SpotStatus): readonly SpotStatus[] {
  return SPOT_STATUS_TRANSITIONS[from];
}

// The three a person sets by hand: a spot becomes reserved by a booking. §7
export const FLOOR_STATUSES = ['free', 'occupied', 'cleaning'] as const;

export const floorStatusSchema = z.enum(FLOOR_STATUSES);

export type FloorStatus = z.infer<typeof floorStatusSchema>;
